"use client"

import Script from "next/script"
import { useEffect, useState, useCallback } from "react"

const GA_ID = "G-BG8RBPM8GH"

export function GoogleAnalytics() {
    const [hasAnalyticsConsent, setHasAnalyticsConsent] = useState<boolean | null>(null)

    const checkConsent = useCallback(() => {
        const analyticsConsent = localStorage.getItem("cookie_consent_analytics")
        setHasAnalyticsConsent(analyticsConsent === "true")
    }, [])

    useEffect(() => {
        checkConsent()

        const handleConsentChange = () => checkConsent()
        window.addEventListener("cookie-consent-update", handleConsentChange)
        return () => window.removeEventListener("cookie-consent-update", handleConsentChange)
    }, [checkConsent])

    // Don't render anything until we know the consent status
    if (hasAnalyticsConsent === null) {
        return null
    }

    // Only load GA4 if analytics consent is given
    if (!hasAnalyticsConsent) {
        return null
    }

    return (
        <>
            {/* Google tag (gtag.js) - Only loaded if consent is given */}
            <Script
                async
                src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
                strategy="afterInteractive"
            />
            <Script
                id="google-analytics"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${GA_ID}', {
                            'anonymize_ip': true,
                            'allow_google_signals': false
                        });
                    `,
                }}
            />
        </>
    )
}
